import type { OrderSource, OrderType } from "../types/order";

export function formatOrderSource(source: OrderSource): string {
  const map: Record<OrderSource, string> = {
    PHONE: "Telefono",
    WAITER: "Cameriere",
    QR: "QR Code",
    CRM: "CRM",
  };
  return map[source] || source;
}

export function formatOrderType(type: OrderType): string {
  const map: Record<OrderType, string> = {
    DINE_IN: "Al tavolo",
    TAKEAWAY: "Asporto",
    DELIVERY: "Consegna",
    COUNTER: "Banco",
  };
  return map[type] || type;
}

export function formatPrice(cents: number): string {
  return `€${(cents / 100).toFixed(2)}`;
}

export function formatDailyNumber(n: number): string {
  return `#${String(n).padStart(3, "0")}`;
}
